import React from 'react';

class ArenaCombatantLaptop extends React.Component {

  props: {
    view: "front" | "back",

  };

  render() {

    const srcImage = this.props.view === "front"
      ? "/images/misc/laptop-screen.svg"
      : "/images/misc/laptop-back.svg";

    const style = {
      position: "absolute",
      left: this.props.view === "front" ? "-0.4em" : "1.4em",
      top: this.props.view === "front" ? "-0.1em" : "2.6em",
      width: this.props.view === "front" ? "4.7em" : "2.6em",
      zIndex: this.props.view === "front" ? "-1" : "3"
    };
    return (
      <img style={style} src={srcImage} alt="Laptop"/>
    )
  }
}

export default ArenaCombatantLaptop;


// WEBPACK FOOTER //
// ./src/battle/ArenaView/ArenaCombatantLaptop.js